import React, {Fragment} from 'react';
import LotteryContent from '../../components/account/LotteryContent';

const Lottery = () => {
    return (
        <Fragment>       
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">복권</div>
                </div>
            </div>
            <LotteryContent />
        </Fragment>
    );
};

export default Lottery;


// WEBPACK FOOTER //
// ./src/containers/Account/Lottery.js